var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{staticClass:"order-action",attrs:{"title":_vm.$t('trade.direction')}},[_c('RadioBox',{attrs:{"disabled":_vm.disabled,"options":_vm.actionTypeList},model:{value:(_vm.orderAction),callback:function ($$v) {_vm.orderAction=$$v},expression:"orderAction"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }